import getName from '../../../../../helpers/getName';

export const generateMasters = (map) => (request) => {
  const { master } = request;
  const id = master?.id || 0;

  const entity = map.get(id) || {
    name: master ? getName(master) : 'Не указан',
    amount: 0,
    speciality: master?.speciality,
    id,
  };

  entity.amount += 1;

  map.set(id, entity);
};
